<template>
  <div class="product-image-carousel" :style="{ height: cssHeight }">
    <b-carousel v-if="imageUrls.length > 1" :interval="0" controls indicators class="h-100" background="#ffffff">
      <b-carousel-slide v-for="(imageUrl, index) in imageUrls" :key="`${imageUrl}-${index}`">
        <template #img>
          <img
            :src="imageUrl"
            :alt="`${productTitle} image ${index + 1}`"
            class="product-image-carousel__image"
            :class="{ 'clickable-item': isClickable }"
            :tabindex="isClickable ? 0 : null"
            :role="isClickable ? 'button' : null"
            @click="$emit('image-click')"
            @keyup.enter="$emit('image-click')"
          />
        </template>
      </b-carousel-slide>
    </b-carousel>

    <img
      v-else
      :src="imageUrls[0]"
      :alt="`${productTitle} image`"
      class="product-image-carousel__image"
      :class="{ 'clickable-item': isClickable }"
      :tabindex="isClickable ? 0 : null"
      :role="isClickable ? 'button' : null"
      @click="$emit('image-click')"
      @keyup.enter="$emit('image-click')"
    />
  </div>
</template>

<script>
import { BCarousel, BCarouselSlide } from 'bootstrap-vue';
import DefaultAvatar from '@/assets/images/logos/logo_icon.png';

export default {
  name: 'ProductImageCarousel',
  components: { BCarousel, BCarouselSlide },
  props: {
    product: {
      type: Object,
      default: () => ({}),
    },
    height: {
      type: [Number, String],
      default: 350,
    },
  },
  computed: {
    cssHeight() {
      return typeof this.height === 'number' ? `${this.height}px` : this.height;
    },
    imageUrls() {
      const product = this.product || {};
      const gallery = Array.isArray(product.product_images) ? product.product_images : [];
      const images = gallery.length ? gallery : [product.product_url];
      const uniqueImages = [...new Set(images.filter(Boolean))];
      return uniqueImages.length ? uniqueImages : [DefaultAvatar];
    },
    productTitle() {
      return (this.product || {}).product_title || 'Product';
    },
    isClickable() {
      return Boolean(this.$listeners['image-click']);
    },
  },
};
</script>

<style scoped>
.product-image-carousel {
  width: 100%;
  overflow: hidden;
  background: #fff;
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
}

.product-image-carousel__image {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.product-image-carousel ::v-deep .carousel-inner,
.product-image-carousel ::v-deep .carousel-item {
  height: 100%;
}

.product-image-carousel ::v-deep .carousel-control-prev-icon,
.product-image-carousel ::v-deep .carousel-control-next-icon {
  border-radius: 50%;
  background-color: rgba(0, 0, 0, 0.55);
  background-size: 55%;
}

.product-image-carousel ::v-deep .carousel-indicators li {
  background-color: #333;
}

</style>
